import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-status-card',
  imports: [TranslatePipe, Skeleton, RouterLink],
  templateUrl: './status-card.html',
  styleUrl: './status-card.scss',
})
export class StatusCard {
  title = input<string>("Card Title");
  value = input<any>(0);
  additionalLinkTitle = input<string>(undefined);
  additionalLinkUrl = input<string>(undefined);

  loading = input<boolean>(false);
  disabled = input<boolean>(false);
  disabledText = input<string>("No Content");
}
